import React, {useState} from 'react'
import {Map} from "../../Map";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useLoadScript} from "@react-google-maps/api";
import {EditJobDescription} from "../../Modals/EditJobDescription";
import './index.scss'

export default function JobInfo({title}) {
  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);
  const { isLoaded } = useLoadScript({googleMapsApiKey: "AIzaSyBL99kJ-59bryhoVvhKkV6a2JlEFZhQG2I",});

  const [showEditJobDescription, setShowEditJobDescription] = useState(false);

  const navigate = useNavigate();
  const sliceTimeInDatetime = (datetime) => {
    return datetime?.slice(datetime.indexOf(",") + 2);
  };

  const textWithBreaks = activeJob?.description?.split('\r\n').map((line, index) => (
    <React.Fragment key={index}>{line}<br /></React.Fragment>
  ));

  const handleReschedule = () => {
    navigate(`/reschedule/${title}`);
  };

  const toggleShowEditJobDescription = () => {
    setShowEditJobDescription(!showEditJobDescription);
  }

  const isAbleReschedule = activeJob?.status === "needs_tech" || activeJob?.status === "pending" || activeJob?.status === "accepted";
  const isAbleEditDesc = activeJob?.status === "needs_tech" || activeJob?.status === "pending" || activeJob?.status === "accepted" || activeJob?.status === "inprogress_way" || activeJob?.status === "inprogress_site";

  return (
      <>
        {showEditJobDescription
            ? <EditJobDescription
                close={toggleShowEditJobDescription}
            />
            : null
        }
        <div className="jobInfo">
          <div className="jobInfo__top">
            <div className="jobInfo__top-left">
              <div className="jobInfo__avatar">
                <img src={activeJob?.provider_company_image || "../../assets/images/job-avatar.png"} alt="avatar"/>
              </div>
              <div>
                <p className="jobInfo__id">ID# {activeJob?.title}</p>
                <p className="jobInfo__text">{activeJob?.provider_company_name}</p>
              </div>
            </div>
            <div className="jobInfo__top-right">
              <div className="jobInfo__price">{accountData?.country_currency_sign} {activeJob?.price}</div>
              <div className={`job__item-status ${activeJob?.status}`}>
                <span className={`job__item-dot ${activeJob?.status}`}></span>
                <span>{
                  activeJob?.status === 'inprogress_site'
                      ? 'On Site' : activeJob?.status === 'inprogress_way'
                          ? 'On The Way'
                          : (activeJob?.status !== 'rescheduled' && Boolean(activeJob?.is_rescheduled)) ? 'Late Rescheduled'
                              : activeJob?.status?.replaceAll('_', ' ')}</span>
              </div>
            </div>
          </div>
          <div className="jobInfo__wrapper">
            <div className="jobInfo__location">
          <span>
            <img src="../../assets/icons/location.svg" alt="location"/>
          </span>
              {activeJob?.address}
            </div>
            <div className="jobInfo__date">
          <span>
            <img src="../../assets/icons/calendar.svg" alt="calendar"/>
          </span>
              {activeJob?.job_datetime}- {sliceTimeInDatetime(activeJob?.job_endtime)}
            </div>
          </div>
          {isAbleReschedule &&
              <div className="jobInfo__info-reschedule">
                <p>Rescheduling over 24 hours in advance is free, but within 24 hours, you’ll be charged the full amount
                  for the original booking.</p>
                <button onClick={handleReschedule} className="btn reschedule-btn jobInfo__reschedule">Reschedule
                </button>
              </div>
          }
          <div className="jobInfo__bottom"
               style={{
                 borderTop: isAbleReschedule && '1px solid #E1E1E1'
               }}
          >
            <div className="jobInfo__bottom_top">
              <p className="jobInfo__label">Description</p>
              { isAbleEditDesc &&
                <div className="jobInfo__edit-pen" onClick={toggleShowEditJobDescription}>
                  <img src="/assets/icons/edit-dark.svg" alt="pen"/>
                  <span>Edit</span>
                </div>
              }
            </div>
            <div className="jobInfo__desc">
              {textWithBreaks}
            </div>
            <div className="jobInfo__map">{isLoaded &&
                <Map
                  radius={'8px'}
                  weight={'100%'}
                  height={'220px'}
                  data={[]}
                  search={
                    activeJob?.lat != null && activeJob?.lon != null
                      ? { lat: activeJob.lat, lon: activeJob.lon }
                      : undefined
                  }
                  jobLocation={
                    activeJob?.lat != null && activeJob?.lon != null
                      ? { lat: activeJob.lat, lon: activeJob.lon }
                      : undefined
                  }
                />}</div>
            <div className="jobInfo__boxiks">
              <div className="jobInfo__boxik">
                {/*<div>*/}
                {/*  <p className="jobInfo__boxik-title">Ticket</p>*/}
                {/*  <p className="jobInfo__boxik-desc">{(activeJob?.ticket_number && activeJob?.ticket_number !== 'null') ? activeJob?.ticket_number : 'N/A'}</p>*/}
                {/*</div>*/}
                <div>
                  <p className="jobInfo__boxik-title">Verification Key</p>
                  <p className="jobInfo__boxik-desc">{(activeJob?.verification_key && activeJob?.verification_key !== 'null') ? activeJob?.verification_key : 'N/A'}</p>
                </div>
                <span>
            <img src="/assets/icons/ticket.svg" alt=""/>
          </span>
              </div>
              <div className="jobInfo__boxik">
                <div>
                  <p className="jobInfo__boxik-title">Tracking number</p>
                  <p className="jobInfo__boxik-desc">{(activeJob?.tracking_number && activeJob?.tracking_number !== 'null') ? activeJob?.tracking_number : 'N/A'}</p>
                </div>
                <span>
            <img src="/assets/icons/link.svg" alt=""/>
          </span>
              </div>
            </div>
          </div>
        </div>
      </>

  )
}
